import React from 'react'
import {Spinner} from 'wix-ui-tpa'
import {classes} from './spinner.st.css'

export const SpinnerExt = props => <Spinner {...props} className={classes.root} />
